import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CommonProcess = () => {
  const searchParams = useLocation().search;
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');

  useEffect(() => {
    if (paramPayUrl) {
      window.location.replace(paramPayUrl);
    }
  }, []);

  return <>In Process...</>;
};

export default CommonProcess;
